import React, { Fragment, useState } from 'react'
import { Flex, Box } from 'reflexbox/styled-components'
import { Formik } from 'formik'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'

import Card from 'components/Card'
import Button from 'components/Button'
import { TextField } from 'components/Form/Fields'
import { SemiTitle, Text } from 'components/Typography'
import Loader from 'components/Loader'
import PublicPageWrapper from 'components/PublicPagesWrapper'
import { useHistory } from 'react-router-dom'

import logo from 'images/guigo_partners_black.svg'

import { FormContainer } from './styles'
import theme from 'styles/theme'
import { forgotPassword } from 'services/users'

const ForgotPassword = () => {
  const [emailHasBeenSent, setEmailHasBeenSent] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const history = useHistory()

  const handleSubmit = async ({ email }) => {
    setLoading(true)
    try {
      const response = await forgotPassword(email)
      setEmailHasBeenSent(true)
    } catch (e) {
      console.log(e)
      toast.error('Falha ao enviar email!')
      setEmailHasBeenSent(false)
    } finally {
      setLoading(false)
    }
  }

  return (
    <PublicPageWrapper>
      <Card maxWidth='384px' bg={theme.colors.white}>
        <Flex flexDirection='column' alignItems='center' justifyContent='center'>
          <Box mb={32}>
            <img src={logo} />
          </Box>
          {emailHasBeenSent ? (
            <Fragment>
              <Box textAlign='center' mb={16}>
                <SemiTitle color={theme.colors.black} as='h3'>
                  E-mail enviado!
                </SemiTitle>
              </Box>
              <Box mb={24}>
                <Text>Um link foi enviado para o seu e-mail.</Text>
              </Box>
              <Button as={({ outlined, ...rest }) => <Link to='login' {...rest} />} size='auto'>
                Voltar para a página inicial
              </Button>
            </Fragment>
          ) : (
            <Fragment>
              <Box textAlign='center' mb={16}>
                <SemiTitle color={theme.colors.black} as='h3'>
                  Esqueceu sua senha?
                </SemiTitle>
              </Box>
              <Text>Insira seu e-mail e enviaremos um email para você redefinir sua senha.</Text>
              <Formik initialValues={{ email: '' }} onSubmit={handleSubmit}>
                <FormContainer>
                  <TextField name='email' type='email' label='email' placeholder='Digite seu e-mail' mb={24} mt={32} />
                  {isLoading ? (
                    <Flex minHeight='13vh' justifyContent='center' alignContent='center' alignItems='center'>
                      <Loader />
                    </Flex>
                  ) : (
                    <>
                      <Box mb={24}>
                        <Button size='auto' disabled={isLoading}>
                          {'Enviar'}
                        </Button>
                      </Box>

                      <Box mb={24}>
                        <Button
                          size='auto'
                          variant='secondary'
                          onClick={() => {
                            history.push('/login')
                          }}
                        >
                          {'Voltar'}
                        </Button>
                      </Box>
                    </>
                  )}
                </FormContainer>
              </Formik>
            </Fragment>
          )}
        </Flex>
      </Card>
    </PublicPageWrapper>
  )
}

export default ForgotPassword
